<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input v-model="listQuery.hotel_id" placeholder="酒店ID" style="width: 200px;" class="filter-item" clearable
                size="small"/>
      <el-input v-model="listQuery.hotel_name" placeholder="酒店名称" style="width: 200px;" class="filter-item"
                clearable size="small"/>
      <el-input v-model="listQuery.room_type_name" placeholder="房型名称" style="width: 200px;" class="filter-item"
                clearable size="small"/>
      <el-select v-model="listQuery.is_reply" placeholder="是否回复" clearable style="width: 120px" class="filter-item"
                 size="small">
        <el-option label="是" value="1"/>
        <el-option label="否" value="0"/>
      </el-select>
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter" size="small">搜索
      </el-button>
    </div>
    <el-table
        v-loading="listLoading"
        :data="list"
        element-loading-text="Loading"
        border
        fit
        highlight-current-row>
      <el-table-column align="center" label="ID" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index }} -->
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="头像" min-width="110" align="center">
        <template slot-scope="scope">
          <span v-if="!scope.row.user||!scope.row.user.avatar">-</span>
          <img :src="scope.row.user.avatar" class="user-avatar" v-else>
        </template>
      </el-table-column>
      <el-table-column label="昵称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.user ? scope.row.user.nickname : '-' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="酒店ID" min-width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.order ? scope.row.order.hotel_id : '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="酒店名称" min-width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.order ? (scope.row.order.hotel ? scope.row.order.hotel.hotel_name : "-") : '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="房型名称" min-width="200">
        <template slot-scope="scope">
          <span>{{
              scope.row.order ? (scope.row.order.room_type ? scope.row.order.room_type.room_type_name : "-") : '-'
            }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="评论内容" min-width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.content }}</span>
        </template>
      </el-table-column>
      <el-table-column label="图片" min-width="110" align="center">
        <template slot-scope="scope">
          <span v-if="!scope.row.images||scope.row.images.length==0">-</span>
          <el-image v-else
                    v-for="(url,key) in scope.row.images"
                    style="width: 50px; height: 50px;margin-right: 5px;"
                    :src="url"
                    :preview-src-list="[url]"
                    :key="key"></el-image>
        </template>
      </el-table-column>
      <el-table-column align="center" label="回复内容" min-width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.reply_content || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="回复时间" min-width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.reply_at || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="评分" min-width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.score }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="位置分" min-width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.location_score }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="服务分" min-width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.service_score }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="卫生分" min-width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.hygiene_score }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="设施分" min-width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.facility_score }}</span>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="是否回复" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_reply == 1" type="success">是</el-tag>
          <el-tag v-else type="warning">否</el-tag>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="是否匿名" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_anonymous == 1" type="success">是</el-tag>
          <el-tag v-else type="warning">否</el-tag>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="是否有图" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_have_images == 1" type="success">是</el-tag>
          <el-tag v-else type="warning">否</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="点赞数" min-width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.like_num }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="created_at" label="评论时间" min-width="200">
        <template slot-scope="scope">
          <i class="el-icon-time"/>
          <span>{{ scope.row.created_at }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="230" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleUpdate(scope.row)">回复</el-button>
          <el-button style="margin: 3px;" size="mini" type="danger"
                     @click="handleDel(scope.row)">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit"
                     :total="total" background layout="total, sizes, prev, pager, next, jumper"
                     @size-change="handleSizeChange" @current-change="handleCurrentChange"/>
    </div>
    <el-dialog title="回复评论" :visible.sync="dialogFormVisible" width="60%"
               :close-on-click-modal="false">
      <el-form ref="form" :rules="rules" :model="form"
               label-width="150px">

        <el-form-item label="回复内容" prop="reply_content">
          <el-input v-model="form.reply_content" type="textarea"
                    :rows="4"/>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
  </div>


</template>

<script>

import request from '@/utils/request'

export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: 'success',
        draft: 'gray',
        deleted: 'danger'
      }
      return statusMap[status]
    }
  },
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        nickname: '',
        is_forbidden: ''
      },
      form: {
        id: null,
        reply_content: ""
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '添加'
      },
      rules: {
        reply_content: [{required: true, message: '回复内容不能为空', trigger: 'blur'}],
      },
      btnLoading: false,
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/hotel/commentList',
        method: 'get',
        params: this.listQuery
      }).then(response => {
        this.list = response.data.data
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    handleForbid(val, text) {
      this.$confirm('此操作将' + text + '该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          url: '/api/backend/user/forbid',
          method: 'post',
          data: {id: val, operate: (text == '解禁' ? 1 : 0)}
        }).then(() => {
          this.getList()
          this.$message({
            type: 'success',
            message: '操作成功!'
          });
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    handleDel(val) {
      this.$confirm('确定要删除, 是否继续?', '提示', {
        type: 'warning'
      }).then(() => {
        request({
          url: '/api/backend/hotel/commentDel',
          method: 'post',
          data: {id: val.id}
        }).then(() => {
          this.getList()
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    resetForm() {
      this.form = {
        id: undefined,
        reply_content: "",
      }
      this.btnLoading = false
    },
    handleUpdate(row) {
      this.resetForm()
      this.form.id = row.id
      this.form.reply_content = row.reply_content
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })
    },
    saveData() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          request({
            url: '/api/backend/hotel/commentReply',
            method: 'post',
            data: this.form
          }).then(response => {
            this.btnLoading = false
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '保存成功',
              type: 'success',
              duration: 2000
            })
            this.getList();
          }).catch((err) => {
            this.btnLoading = false
          })
        }
      })
    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
</style>
